import script from "./DetailsD1.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsD1.vue?vue&type=script&setup=true&lang=js"

import "./DetailsD1.vue?vue&type=style&index=0&id=220b35f8&scoped=true&lang=css"
script.__scopeId = "data-v-220b35f8"

export default script